import { memo, useEffect, useState } from "react";
import styled from "styled-components";
import { IoChevronDown } from "react-icons/io5";
import { PiSlidersHorizontalBold } from "react-icons/pi";
import { useAtom } from 'jotai';
import { showMapViewAtom } from "./store";
import { isMapLoadedDoneAtom } from "~/components/Map/stores/mapStore";

const MapView = () => {
  const [zoomLevel, setZoomLevel] = useState(0);
  const [showPanel, setShowPanel] = useAtom(showMapViewAtom);
  const [isMapLoadedDone, setMapLoadedDone] = useAtom(isMapLoadedDoneAtom);

  useEffect(() => {
    if (window.map) {
      window.map.on('zoomend', () => {
        const zoomLevel = window.map!.getZoom();
        setZoomLevel(zoomLevel);
      });
      // Initial zoom
      setZoomLevel(window.map.getZoom());
    }
  }, [isMapLoadedDone]);

  return (
    <UI_ViewMenuButton
      $active={showPanel}
      onClick={(e) => {
        e.stopPropagation();
        setShowPanel(!showPanel);
      }}
      title="Bảng điều khiển hiển thị và tính năng"
    >
      <PiSlidersHorizontalBold style={{ fontSize: '15px' }} />
      <span>Hiển thị</span>
      <UI_ZoomBadge title={`Mức thu phóng: ${zoomLevel.toFixed(1)}`}>
        {zoomLevel.toFixed(1)}
      </UI_ZoomBadge>
      <IoChevronDown style={{ fontSize: '12px', opacity: 0.7 }} />
    </UI_ViewMenuButton>
  );
};

export default memo(MapView);

const UI_ViewMenuButton = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  cursor: pointer;
  border-radius: 6px;
  background-color: ${({ $active }) => ($active ? 'rgba(59, 130, 246, 0.12)' : 'transparent')};
  color: ${({ $active }) => ($active ? '#2563eb' : '#334155')};
  font-size: 13px;
  font-weight: 500;
  user-select: none;
  transition: all 0.2s ease;
  border: 1px solid ${({ $active }) => ($active ? '#93c5fd' : 'transparent')};

  &:hover {
    background-color: rgba(59, 130, 246, 0.08);
    color: #2563eb;
    border-color: #cbd5e1;
  }

  @media (max-width: 768px) {
    padding: 6px 8px;
    font-size: 12px;
  }
`;

const UI_ZoomBadge = styled.span`
  font-size: 11px;
  font-family: monospace;
  font-weight: 600;
  padding: 1px 5px;
  background: rgba(0, 0, 0, 0.05);
  color: #64748b;
  border-radius: 4px;
`;